<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1300px"
      title="销货单 详情"
      id-key="DocId"
      :data="data"
      :form-rules="rules"
      :save-func="() => {}"
      :get-data-func="api.info"
      @details-opened="onDetailsOpened"
    >
      <template slot="form">
        <el-row>
          <el-col :span="6">
            <el-form-item label="单据编号" prop="DocNo">
              <span>{{ data.DocNo }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="单据日期" prop="DocDate">
              <span>{{ $commonJs.toDateString(data.DocDate) }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- <el-form-item label="客户名称" prop="CustomerId" v-if="!_readonly">
              <customer @restaurants="setSupplier" :state="data.CustomerName" />
            </el-form-item> -->
            <el-form-item label="客户名称" prop="CustomerName">
              <span>{{ data.CustomerName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="销售单号" prop="OrderNo">
              <span>{{ data.OrderNo }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="收款条件" prop="ReceiptConditionId">
              <span>{{ data.ReceiptConditionName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- <el-form-item label="票据类型" prop="InvoiceType" v-if="!_readonly">
              <invoice-select
                v-model="data.InvoiceType"
                @change="invoiceChange"
                :clearable="false"
              />
            </el-form-item> -->
            <el-form-item label="票据类型" prop="InvoiceTypeName">
              <span>{{ data.InvoiceTypeName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="data.NeedInvoice">
            <!-- <el-form-item label="发票号码" prop="InvoiceNo" v-if="!_readonly">
              <el-input v-model="data.InvoiceNo" placeholder="请输入发票号码"></el-input>
            </el-form-item> -->
            <el-form-item label="发票号码" prop="InvoiceNo">
              <span>{{ data.InvoiceNo }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="data.NeedInvoice">
            <!-- <el-form-item label="发票金额" prop="InvoiceAmount" v-if="!_readonly">
              <el-input v-model="data.InvoiceAmount" placeholder="请输入发票金额"></el-input>
            </el-form-item> -->
            <el-form-item label="发票金额" prop="InvoiceAmount">
              <span>{{ data.InvoiceAmount }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="交货方式">
              <span v-if="data.FreightMode == 0">异地配送</span>
              <span v-if="data.FreightMode == 1">本地配送</span>
              <span v-if="data.FreightMode == 2">自提</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="业务员" prop="ClerkName">
              <span>{{ data.ClerkName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="仓库" prop="WarehouseId" v-if="!readonly1">
              <select-input
                placeholder="选择仓库"
                :label="data.WarehouseName"
                v-model="data.WarehouseId"
                @click="openWarehouse"
              />
            </el-form-item>
            <el-form-item label="仓库" prop="WarehouseName" v-else>
              <span>{{ data.WarehouseName }}</span>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="支付方式" prop="PayType" v-if="data.PayType">
              <span v-if="data.PayType == 1">余额支付</span>
              <span v-else-if="data.PayType == 2">信用支付</span>
              <span v-else-if="data.PayType == 3">微信支付</span>
              <span v-else>其他</span>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row>
          <el-col :span="6">
            <el-form-item label="退货状态">
                <span v-if="data.RefundStatus == 1">退款待审</span>
                <span v-else-if="data.RefundStatus == 2">客户取消</span>
                <span v-else-if="data.RefundStatus == 3">同意退款</span>
                <span v-else-if="data.RefundStatus == 4">拒绝退款</span>
                <span v-else>无</span>
            </el-form-item>
          </el-col>
          
          <el-col :span="6">
            <el-form-item label="收货人" prop="Person">
              <span>{{ data.Person }}</span>
            </el-form-item> </el-col>
            <el-col :span="6">
            <el-form-item label="联系电话" prop="Phone">
              <span>{{ data.Phone }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注" prop="Remark">
              <span>{{ data.Remark }}</span>
            </el-form-item>
          </el-col>
          <dialog-list
            ref="dialogList"
            :info="data"
            readonly
            @getList="getList"
          />
        </el-row>
        <el-col :span="6">
          <el-form-item label="无税金额" prop="NoTaxAmount">
            <span>{{ $commonJs.toThousands(data.NoTaxAmount) }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="税额" prop="TaxAmount">
            <span>{{ $commonJs.toThousands(data.TaxAmount) }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="订单金额" prop="Amount">
            <span>{{ $commonJs.toThousands(data.Amount) }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="收款金额" prop="ReceiptAmount">
            <span>{{ $commonJs.toThousands(data.ReceiptAmount) }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="剩余金额" prop="RemainAmount">
            <span>{{ $commonJs.toThousands(data.RemainAmount) }}</span>
          </el-form-item>
        </el-col>
        <el-row>
          <el-row>
            <el-col :span="24">
              <el-divider />
              <span style="margin-left: 16px; line-height: 50px">收款信息</span>
            </el-col>
          </el-row>
          <el-row v-for="(i, key) in data.Receipts" :key="key">
            <el-col :span="6">
              <el-form-item label="结算方式" prop="SettleId">
                <span>{{ i.SettleName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="收款账号" prop="AccountId">
                <span>{{ i.Bank + i.AccountName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="收款金额" prop="ReceiptAmount">
                <span>{{ i.ReceiptAmount }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="1"></el-col>
          </el-row>
        </el-row>
      </template>
      <template slot="footer">
        <el-button type="danger" @click="cancelExamine" v-if="data.Status == 2"
          >弃 审</el-button
        >
        <el-button type="success" @click="examine" v-else-if="data.Status!= 4">审 核</el-button>
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
    <warehouse-dialog
      ref="warehouseDialog"
      in-dialog
      selectable
      @select="setWarehouse"
      title="仓库列表"
      :typeList="[1, 2]"
    />
  </div>
</template>
<script>
import customer from "@/components/common/customer/customer";
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import dialogList from "./dialogList";
import warehouseDialog from "@/components/basicinfo/basic/warehouse/listDialog";
import invoiceSelect from "@/components/basedoc/invoice/select";
export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    dialogList,
    invoiceSelect,
    warehouseDialog,
    customer,
  },
  data() {
    return {
      readonly1: "",
      data: {
        DocId: 0,
        DocNo: "",
        DocDate: "",
        // SaDocId: 0,
        BrandCode: "",
        CustomerId: "",
        CustomerName: "",
        CustomerType: 1,
        SaDocNo: "",
        InvoiceType: "",
        InvoiceTypeName: "",
        NeedInvoice: true,
        InvoiceNo: "",
        InvoiceAmount: "",
        FreightMode: 0,
        Remark: "",
        ActualFreight: 0,
        NoTaxAmount: 0,
        TaxAmount: 0,
        ReceiptAmount: 0,
        Amount: 0,
        RemainAmount: 0,
        ReceiptConditionId: null,
        ReceiptConditionName: "",
        ClerkName: "",
        ClerkId: 0,
        OrderNo: "",
        OrderId: 0,
        Status: 0,
        Goods: [],
        ShowTax: 0,
        OutStatus: 0,
        CompleteStatus: 0,
        ReceiptStatus: 0,
        InvoiceStatus: 0,
        WarehouseId: "",
        WarehouseName: "",
        PayType : 0,
        RefundStatus: 0,
        Receipts: [],
        Goods: [],
        Phone:"",
        Person:""
      },
      api: require("@/api/sale/saDoc").default,
      rules: {
        WarehouseId: [{ required: true, message: "仓库不能为空" }],
        InvoiceType: [{ required: true, message: "票据类型不能为空" }],
        // ClerkName: [{ required: true, message: "业务员不能为空" }],
        CustomerId: [{ required: true, message: "客户名称不能为空" }],
        InvoiceNo: [{ required: true, message: "发票号码不能为空" }],
        InvoiceAmount: [{ required: true, message: "发票金额不能为空" }],
      },
    };
  },

  methods: {
    setReadonly(bool) {
      this.readonly1 = bool;
    },
    setSupplier(data) {
      this.data.CustomerId = data.TradeUnitId;
      this.data.CustomerName = data.TradeUnitName;
      this.data.CustomerType = data.TradeUnitType;
    },
    setWarehouse(e) {
      this.data.WarehouseId = e.WarehouseId;
      this.data.WarehouseName = e.WarehouseName;
      let tableData = [];
      // this.$refs.dialogList.tableData.forEach((v) => {
      // v.GoodsName=""
      // v.GoodsId=""
      // v.BarCode=""
      // v.Model=""
      // v.UnitName=""
      // v.WarehouseId = e.WarehouseId;
      // // v.DAccount = JSON.parse(JSON.stringify(res.Data));
      // this.$refs.dialogList.accountkey = Math.random();
      // tableData.push(v);
      // });
      // this.$refs.dialogList.tableData = tableData;
    },
    openWarehouse(e) {
      this.$refs.warehouseDialog.open().then((that) => {
        that.getData({});
        that.getTree();
      });
    },
    invoiceChange(e, data, type) {
      this.data.NeedInvoice = data.NeedInvoice;

      if (!data.NeedInvoice) {
        this.data.InvoiceNo = "";
        this.data.InvoiceAmount = "";
      }
      this.$nextTick(() => {
        this.$refs.dialogList.setDefTaxRate(data.DefTaxRate, type);
      });
    },
    getList(list) {
      let Amount = null;
      let TaxAmount = null;
      let ReceiptAmount = this.data.ReceiptAmount || 0;
      list.forEach((item) => {
        if (item.T != 2) {
          Amount += Number(item.Amount);
          TaxAmount += Number(item.TaxAmount);
        }
      });
      this.data.Amount = Amount;
      this.data.TaxAmount = TaxAmount;
      this.data.NoTaxAmount = Amount - TaxAmount;
      this.data.RemainAmount = Amount - ReceiptAmount;
    },
    examine() {
      if (!this.data.WarehouseId) {
        this.$message.error("请填写仓库");
        return;
      }
      this.$confirm("确认通过吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let data = JSON.parse(JSON.stringify(this.data));
        data.Goods = [];
        data.Receipts = [];
        this.api
          .save(data)
          .then((res) => {
            return res;
          })
          .then((res) => {
            if (res.Code == 0) {
              this.api.examine(this.data.DocId).then((res) => {
                if (res.Code == 0) {
                  this.$message.success("审核成功");

                  this.close();
                  this.$emit("close-saved");
                } else {
                  this.$message.error(res.Msg);
                }
              });
            }
          });
      });
    },
    cancelExamine() {
      this.$confirm("确认弃审吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.api.cancelExamine(this.data.DocId).then((res) => {
          if (res.Code == 0) {
            this.$message.success("弃审成功");

            this.close();
            this.$emit("close-saved");
          } else {
            this.$message.error(res.Msg);
          }
        });
      });
    },
    onDetailsOpened(row) {
      this.readonly = true;

      this.$refs.dialogList.tableData = [];
      this.$refs.dialogList.tableDel = [];
      this.$refs.dialogList.getData();
      if (this.data.InvoiceType == 0) {
        // this.data.InvoiceType = null;
        this.$refs.dialog.clearValidate();
      }
    }
  },
};
</script>
<style lang="scss">
.is-disabled {
  input,
  textarea {
    background-color: #fff !important;
    color: #333 !important;
  }
}
</style>